export default "__VITE_ASSET__CMlTRRR3__"